import Route from 'mewe/routes/route';
import { action } from '@ember/object';

export default class Members extends Route {
  theme = 'group';

  model() {
    return this.modelFor('app.group');
  }

  @action
  willTransition() {
    this.controller.set('model.membersSearch', null);
  }
}
